import React from 'react';
import { PasscodeGate } from './components/PasscodeGate';
import { RealRates } from './pages/RealRates';
import { DEFAULT_HAUL_RATE } from './utils/geo';
interface AppProps {
  /** Haul radius, in miles, measured from the delivery address. */
  radiusMiles?: number;
  /** Estimated trucking rate, in dollars per loaded mile. */
  haulRatePerMile?: number;
  /** Load size priced out on every row, in tons or cubic yards. */
  loadUnits?: number;
  /** Require the shared crew passcode before showing cost basis. */
  requirePasscode?: boolean;
}
export function App({
  radiusMiles = 30,
  haulRatePerMile = DEFAULT_HAUL_RATE,
  loadUnits = 15,
  requirePasscode = true
}: AppProps) {
  const page = <RealRates radiusMiles={radiusMiles} haulRatePerMile={haulRatePerMile} loadUnits={loadUnits} data-id="element-0" data-mp="2wjgu3r3habkn" />;
  if (!requirePasscode) return page;
  return <PasscodeGate passcode="206only" data-id="element-1" data-mp="28s30zixi6bym">{page}</PasscodeGate>;
}